import React, { ReactNode } from 'react';
import { connect } from 'react-redux';
import Jumbotron from '@shorelight/ui-common-components/cjs/components/containers/Jumbotron';

import { ApplicationState } from '../../store/types';

export interface ErrorStateBoundaryProps {
  errorPageContent?: BasicPageContent;
  error?: string;
  children: ReactNode;
}

const fallbackErrorTitle = `We're sorry. There was a problem connecting to our servers. Please try again later`;
export const ErrorStateBoundary = (props: ErrorStateBoundaryProps) => {
  const { error, children, errorPageContent } = props;

  if (error) {
    const errorTitle = errorPageContent?.title || fallbackErrorTitle;
    const errorContent = errorPageContent?.content || error;

    return (
      <div data-testid={'error-boundary'}>
        <Jumbotron title={errorTitle} content={<span>{errorContent}</span>} />
      </div>
    );
  }

  return <>{children}</>;
};

const mapStateToProps = (state: ApplicationState) => {
  const schema = state.wizard.schema;
  const handledErrorMessage = state.wizard.fetchError;

  return {
    error: handledErrorMessage,
    errorPageContent: schema && schema.errorPageContent
  };
};

export default connect(mapStateToProps)(ErrorStateBoundary);
